import React from 'react';
import { Input, Button,Modal,Icon,message,Form } from 'antd';
import abortAjaxHoc from 'components/abortAjaxHoc';
import {withRouter} from 'react-router-dom';
import TitleDivision from 'components/TitleDivision';
import Clipboard from 'clipboard';
import LoadingCover from 'components/LoadingCover';

const {TextArea} = Input;
/**
 * info
 * {
 *  encryption_type:1ras,2sm2
 *  public_key:'sss',
 *  key:'2222'
 * }
 */
const typeMap = {
    1:'RSA',
};
class Encryption extends React.Component {

    constructor(props){
        super(props);
        this.infoList = [{
            encryption_type:1,
            text_type:'rsa'
        }];
        const keys = {},faceIdKeys = {};
        this.infoList.forEach(item=>{
            keys[item.encryption_type] = '';
            faceIdKeys[item.encryption_type] = '';
        });
        this.state = {
            loading:true,
            keys,
            faceIdKeys
        };
    }
    componentDidMount(){
        //获取加密数据/accounts/encryption
        new Clipboard('#clip');
        this.refresh();
    }

    refresh = ()=>{
        this.setState({loading:true});
        this.props.abortableAjax('GET','/accounts/encryption').then(res=>{
            const data = res.data;
            const keys = {},faceIdKeys = {};
            this.infoList.forEach(item=>{
                const oneKey = data[item.text_type];
                if(oneKey){
                    keys[item.encryption_type] = oneKey.output;
                    faceIdKeys[item.encryption_type] = oneKey.input;
                }
            });
            this.setState({loading:false,keys,faceIdKeys});
        });
    }

    onsubmit = (type)=>{
        const public_key = this.state.keys[type];
        const faceidKey = this.state.faceIdKeys[type];
        if(public_key === ''){
            Modal.error({
                title:'Please enter your public key'
            });
            return;
        }
        Modal.confirm({
            title:'warning',
            content:'Please confirm again that the public key is filled in correctly. If you need to modify the submitted public key, please pause the service first and restart the service after the modification is completed.',
            onOk:()=>{
                const params = {
                    encryption_type:type,
                    public_key:this.state.keys[type]
                };
                //区分创建/更新，当对应的faceidkey为空，则为创建
                let method = 'POST';
                if(faceidKey === ''){
                    method = 'PUT';
                }
                this.setState({loading:true});
                this.props.abortableAjax(method,'/accounts/encryption',params).then(()=>{
                    message.success('submit success');
                    this.refresh();
                }).catch(()=>{
                    this.setState({loading:false});
                });
            }
        });
    }

    onKeyChange = (type,e)=>{
        const {keys} = this.state;
        keys[type] = e.target.value;
        this.setState({keys});
    }

    onSubmitIPForm = ()=>{
        this.props.form.validateFields((errors, values)=>{
            if(!errors){
                this.setState({loading:true});
                this.props.abortableAjax('post','/accounts/ip_config',values).then(()=>{
                    this.setState({loading:false});
                    message.success('submit success');
                }).catch(()=>{
                    this.setState({loading:false});
                });
            }
        });
    }

    render() {
        const {keys} = this.state;
        return (
            <div style={{paddingTop:20,width:600}}>
                <LoadingCover spinning={this.state.loading}>
                    {this.infoList.map((item,index)=>{
                        const type = item.encryption_type;
                        const typeName = typeMap[item.encryption_type];
                        const noKey = this.state.faceIdKeys[type]==='';
                        let publicKey = this.state.faceIdKeys[type];
                        if(publicKey === ''){
                            publicKey = `Please submit your ${typeName} public key `;
                        }
                        return <div key={index} style={{marginBottom:20}}>
                            <TitleDivision>{typeName} encryption configuration</TitleDivision>
                            <div style={{margin:'10px 0'}}>Client {typeName} public key:</div>
                            <div>
                                <TextArea
                                    style={{fontFamily:'Menlo'}}
                                    onChange={this.onKeyChange.bind(this,type)}
                                    value={keys[type]}
                                    placeholder="Please enter your public key"
                                    rows={6}
                                />
                                <Button onClick={this.onsubmit.bind(this,item.encryption_type)} style={{marginTop:20}} type="primary">submit</Button>
                            </div>
                            <div style={{margin:'10px 0'}}>FaceID {typeName} public key:</div>
                            <div style={{fontFamily:'Menlo',whiteSpace:'pre-line'}}>{noKey?<Icon style={{color:'red',marginRight:5}} type="exclamation-circle" />:null}{publicKey}</div>
                            <Button
                                disabled={noKey}
                                id="clip"
                                data-clipboard-text={publicKey}
                                style={{marginTop:20}}
                            >copy</Button>
                        </div>;
                    })}
                </LoadingCover>
            </div>
        );
    }
}

export default Form.create()(abortAjaxHoc(withRouter(Encryption)));



// WEBPACK FOOTER //
// ./src/pages/Encryption/index.js